module.exports = __webpack_public_path__ + "img/au-logo-screenshot.png";